export default "__VITE_ASSET__B0CJYU$z__"